import { UserProfileBasicData, UserProfileRelation, UserProfileRelationType } from 'core-lib';

/**
 * Gibt das Relation-Label ("Child of", "Parent of", "Spouse or partner of") 
 * automatisch aus Sicht von currentProfileId zurück.
 */
export function getRelationLabel(
  relation: UserProfileRelation,
  currentProfileId: string
): string {
  if (!relation || !relation.type) return '';

  const fromId = relation?.from?.id;
  const toId = relation?.to?.id;

  const isFromSide = fromId === currentProfileId;
  const isToSide = toId === currentProfileId;

  switch (relation.type as UserProfileRelationType) {
    case UserProfileRelationType.PartnerOf:
      // symmetrisch – beide Seiten gleich
      return $localize`:@@userprofile.relation.partnerOf:Spouse or partner of`;

    case UserProfileRelationType.ChildOf:
      // from = child, to = parent
      if (isFromSide) {
        return $localize`:@@userprofile.relation.childOf:Child of`;
      }
      if (isToSide) {
        return $localize`:@@userprofile.relation.parentOf:Parent of`;
      }
      // fallback – falls currentProfileId weder from noch to ist
      return $localize`:@@userprofile.relation.childOf:Child of`;

    default:
      return String(relation.type);
  }
}

export function getFamilyMembersSimple(
  relations: UserProfileRelation[],
  myProfileId: string
): UserProfileBasicData[] {
  if (!relations || !myProfileId) return [];

  const seen = new Set<string>();
  const result: UserProfileBasicData[] = [];

  for (const r of relations) {
    const from = r?.from;
    const to   = r?.to;

    // Kandidat ist "die andere Seite"
    const candidate =
      from?.id && from.id !== myProfileId ? from :
      to?.id   && to.id   !== myProfileId ? to   :
      null;

    if (candidate?.id && !seen.has(candidate.id)) {
      seen.add(candidate.id);
      result.push(candidate);
    }
  }

  return result;
}


